import React from 'react'

import { SxProps } from '@mui/material'

import Box from 'components_new/atoms/Box'
import Button from 'components_new/atoms/Button'
import Emoji from 'components_new/atoms/Emoji'

import EmptyPlaceholder from 'components_new/molecules/EmptyPlaceholder'
import { useTranslation } from 'language/translator'

interface Props {
  sx?: SxProps
}

const Empty = (props: Props) => {
  const { sx } = props

  const { t } = useTranslation()

  return (
    <Box sx={sx}>
      <EmptyPlaceholder
        actions={
          <Button to="/dashboards">{t('groups', 'no_resources_cta')}</Button>
        }
        background={true}
        body={t('groups', 'no_resources_body')}
        height={512}
        size="medium"
        title={
          <>
            {t('groups', 'no_resources_title')} <Emoji name="seedling" />
          </>
        }
      />
    </Box>
  )
}

export default Empty
